import store from '../actions/store';
// Mapeo de tipoEntrega
export const tipoEntregaMap = {
    1: "Envío a domicilio o sucursal correo",
    2: "Retiro en sucursal",
    3: "Envío propio"
};

export const getTipoEntregaString = (ids) => {
    if (Array.isArray(ids)) {
        // Si hay más de un tipo, los concatena con ' / '
        return ids.map(id => tipoEntregaMap[id] || "Desconocido").join(" / ");
    }
    return tipoEntregaMap[ids] || "Desconocido";
};


export const idEstadosPublicacion = {
    "activo": 1,
    "pausado": 2,
    "pendiente_activacion": 3,
    "en_revision": 4,
    "eliminado": 5
}

export const getIdEstadoPublicacion = (label) => {
    return idEstadosPublicacion[label] || 1;
}

export const getEstadoPublicacionFromId = (id) => {
    const estado = Object.keys(idEstadosPublicacion).find(key => idEstadosPublicacion[key] === id);
    return estado || "desconocido";
}

export const switchCardEstado = (idEstado) => {
    const { activo, pausado, pendiente_activacion, en_revision } = idEstadosPublicacion;
    let estadoId = idEstado;
    // Si recibe string, lo convierte a id
    if (typeof idEstado === "string") {
        estadoId = idEstadosPublicacion[idEstado] || null;
    }
    let text = "", color = "";
    switch (estadoId) {
        case activo:
            text = "ACTIVO";
            color = "success";
            break;
        case pendiente_activacion:
            text = "PENDIENTE";
            color = "grey";
            break;
        case pausado:
            text = "PAUSADO";
            color = "red";
            break;
        case en_revision:
            text = "EN REVISIÓN";
            color = "primary";
            break;
        case null:
        default:
            text = "DESCONOCIDO";
            color = "secondary";
            break;
    }
    return { text, color }
}

export const parsePublicacion = (publicacion) => {
    publicacion.precioLista = formatCurrencyToNumber(publicacion.precioLista);
    publicacion.precioPromocional = formatCurrencyToNumber(publicacion.precioPromocional);
    publicacion.idTipoPublicacion = Number.parseInt(publicacion.idTipoPublicacion);
    publicacion.idMotivoRevision = Number.parseInt(publicacion.idMotivoRevision);
    publicacion.garantiaFabrica = publicacion.garantiaFabrica || 0;
    publicacion.garantiaExtActiva = publicacion.garantiaFabrica > 0;
    publicacion = fixDimensionesInt(publicacion);

    let json_stringify = JSON.stringify(publicacion);
    let publicacionParsed = JSON.parse(json_stringify);
    delete publicacionParsed.imagenes;

    return publicacionParsed;
}

const fixDimensionesInt = (publicacion) => {
    let dimensionFix = [];

    const tieneValorDimension = (value) => {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string' && value.trim() === '') return false;

        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) && parsed !== 0;
    };

    if (Array.isArray(publicacion.dimensiones)) {
        publicacion.dimensiones.forEach((obj, index) => {
            if (!['alto', 'ancho', 'peso', 'profundidad'].some((field) => tieneValorDimension(obj?.[field]))) {
                return;
            }

            let alto = Number.parseFloat(publicacion.dimensiones[index].alto);
            let ancho = Number.parseFloat(publicacion.dimensiones[index].ancho);
            let peso = Number.parseFloat(publicacion.dimensiones[index].peso);
            let profundidad = Number.parseFloat(publicacion.dimensiones[index].profundidad);

            let dimension = {
                "alto": alto,
                "ancho": ancho,
                "peso": peso,
                "profundidad": profundidad
            };

            dimensionFix.push(dimension);
        })
    }

    let publicacionFix = { ...publicacion, dimensiones: dimensionFix }
    return publicacionFix;
}

export const nuevaPublicacion = () => {
    let state = store.getState();

    return {
        idSeller: state.general.idSeller,
        observacion: "",
        titulo: "",
        ean: "",
        skuMarket: '',
        precioLista: null,
        precioPromocional: null,
        linkYoutube: "",
        descripcionAmpliada: "",
        tipoEntrega: 1,
        envioGratis: true,
        dimensiones: [{
            alto: 0,
            ancho: 0,
            profundidad: 0,
            peso: 0,
        }],
        alto: 1,
        ancho: 1,
        profundidad: 1,
        peso: 1,
        categoria: 0,
        marca: 0,
        skuSeller: "",
        stock: 0,
        imagenes: [],
        idTipoPublicacion: 0,
        envioPropio: false,
        garantiaExtActiva: false,
        garantiaFabrica: 0,
        codigoLegibilidad: "",
        idMoneda: 0,
        alicuotaIva: null,
        alicuotaImpuestoInterno: null
    }
}

export const mapPublicacion = (p) => {
    let publicacion = null;
    let tipoEntregaIds = [];
    if (p !== undefined) {
        if (Array.isArray(p.tipoEntrega)) {
            p.tipoEntrega.map((tipo) => tipoEntregaIds.push(tipo.codigo));
        }

        // Normalización defensiva para tipoPublicacion (puede venir como string o con casing distinto)
        const tipoPubRaw = p.tipoPublicacion ?? p.TipoPublicacion ?? null;
        const idTipoPubRaw =
            p.idTipoPublicacion ?? p.IdTipoPublicacion
            ?? (tipoPubRaw && typeof tipoPubRaw === "object" ? (tipoPubRaw.codigo ?? tipoPubRaw.Codigo) : null)
            ?? 0;

        const tipoPublicacionObj = tipoPubRaw == null
            ? null
            : (typeof tipoPubRaw === "object"
                ? {
                    ...tipoPubRaw,
                    codigo: tipoPubRaw.codigo ?? tipoPubRaw.Codigo ?? idTipoPubRaw ?? 0,
                    descripcion: tipoPubRaw.descripcion ?? tipoPubRaw.Descripcion ?? "",
                    comision: tipoPubRaw.comision ?? tipoPubRaw.Comision ?? 0,
                    cantidadCuotas: tipoPubRaw.cantidadCuotas ?? tipoPubRaw.CantidadCuotas ?? 0
                }
                : {
                    codigo: idTipoPubRaw ?? 0,
                    descripcion: String(tipoPubRaw),
                    comision: 0,
                    cantidadCuotas: 0
                });

        publicacion = {
            idPublicacion: p.idPublicacion,
            idSeller: p.idSeller,
            observacion: p.observacion,
            titulo: p.titulo,
            skuMarket: p.skuMarket,
            ean: p.ean,
            precioLista: currencyFormatInMapping(p.precioLista),
            precioPromocional: currencyFormatInMapping(p.precioPromocional),
            linkYoutube: p.linkYoutube,
            descripcionAmpliada: p.descripcionAmpliada,
            tipoEntrega: p.envioGratis ? [1] : tipoEntregaIds,
            envioGratis: p.envioGratis,
            dimensiones: p.dimensiones,
            categoria: p.categoria.codigo,
            descripcionCategoria: p.categoria.descripcion,
            marca: p.marca.codigo,
            descripcionMarca: p.marca.descripcion,
            skuSeller: p.skuSeller,
            stock: p.stock,
            estado: getEstadoPublicacionFromId(p.estado),
            imagenes: p.imagenes ?? [],
            idTipoPublicacion: idTipoPubRaw ?? 0,
            fechaUltimaModificacion: p.fechaUltimaModificacion,
            idMotivoRevision: p.motivoRevision.codigo,
            observacionesRevision: p.motivoRevision.observacionesRevision,
            nombreSeller: p.seller.descripcion,
            tipoPublicacion: tipoPublicacionObj,
            tieneRebate: p.tieneRebate,
            envioPropio: p.envioPropio,
            garantiaExtActiva: p.garantiaExtActiva,
            garantiaFabrica: p.garantiaFabrica,
            codigoLegibilidad: p.codigoLegibilidad,
            idUser: p.idUser,
            alicuotaIva: p.alicuotaIva,
            alicuotaImpuestoInterno: p.alicuotaImpuestoInterno,
            zonasEnvioGratis: p.zonasEnvioGratis,
            seller: p.seller,
        }
    }
    return publicacion;
}

// MOVER A LA CARPETA UTILITIES YA QUE NO SE REUTILIZA SOLO EN PUBLICACIONES
export const currencyFormat = (num) => {
    if (typeof num !== "string") num = num.toString();
    if (Number.isNaN(num) || num === "") return "";

    let lastCharacterIsNotComma = (num[num.length - 1] !== ",");

    if (lastCharacterIsNotComma) {

        let dotsRemovedNumber = num.replaceAll(".", "");
        let commasReplacedNumber = dotsRemovedNumber.replaceAll(",", ".");
        let floatNumber = Number.parseFloat(commasReplacedNumber);
        let formattedNumber = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(floatNumber);
        return formattedNumber;
    } else {
        return num;
    }
}

export const currencyFormatInMapping = (num) => {
    if (typeof num === "string") num = Number(num);

    let formattedNumber = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
    return formattedNumber;
}

export const formatCurrencyToNumber = (num) => {
    let numIsEmpty = (num === "" || num == null);
    if (numIsEmpty) return null;
    if (typeof num === "number") return num;
    if (typeof num !== "string") num = num.toString();

    let dotsRemovedNumber = num.replaceAll(".", "");
    let commasReplacedNumber = dotsRemovedNumber.replaceAll(",", ".");
    let formattedNumber = Number(commasReplacedNumber);
    return formattedNumber;
}


export const resetPublicacion = () => ({
    titulo: "",
    ean: "",
    precioLista: null,
    descripcionAmpliada: "",
    dimensiones: [{ alto: 0, ancho: 0, profundidad: 0, peso: 0 }],
    categoria: undefined,
    marca: undefined,
    stock: 0,
    skuSeller: "",
    imagenes: [],
    idTipoPublicacion: 0,
    alicuotaIva: null,
    alicuotaImpuestoInterno: null
});
